import React from 'react';
import { Box, Grid, Paper, Typography, Button } from '@mui/material';
import {
    PersonAdd as EnrollIcon,
    Receipt as InvoiceIcon,
    Payment as PaymentIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PosPage, { PosPageHandle } from './PosPage';

const ReceptionistDashboard = () => {
    const navigate = useNavigate();

    const QUICK_ACTIONS = [
        { label: 'Enroll Student', icon: <EnrollIcon />, path: '/dashboard/students?action=create' },
        { label: 'Create Invoice', icon: <InvoiceIcon />, path: '/dashboard/invoices?action=new' },
        { label: 'Process Payment', icon: <PaymentIcon />, path: '/dashboard/payments?action=new' },
        { label: 'Checkout', icon: <PaymentIcon />, path: 'checkout', isCheckout: true },
    ];

    const posRef = React.useRef<PosPageHandle>(null);

    const handleAction = (action: any) => {
        if (action.isCheckout) {
            posRef.current?.triggerCheckout();
        } else {
            navigate(action.path);
        }
    };

    return (
        <Box sx={{ px: 3, pt: 1, display: 'flex', flexDirection: 'column', gap: 2, height: 'calc(100vh - 84px)', overflow: 'hidden' }}>
            {/* Quick Actions Header */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    borderRadius: '16px',
                    bgcolor: 'white',
                    border: '1px solid #edf2f7',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Typography variant="h6" fontWeight={800} color="#1a237e">Quick Actions</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 9 }}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {QUICK_ACTIONS.map((action) => (
                                <Button
                                    key={action.label}
                                    variant="contained"
                                    startIcon={action.icon}
                                    onClick={() => handleAction(action)}
                                    sx={{
                                        px: 3,
                                        py: 1,
                                        borderRadius: '12px',
                                        textTransform: 'none',
                                        fontWeight: 800,
                                        bgcolor: '#ffab00',
                                        color: '#1a237e',
                                        boxShadow: '0 4px 12px rgba(255, 171, 0, 0.2)',
                                        '&:hover': {
                                            bgcolor: '#ffc107',
                                            boxShadow: '0 6px 15px rgba(255, 171, 0, 0.3)',
                                        }
                                    }}
                                >
                                    {action.label}
                                </Button>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* POS Interface - Occupies the rest of the space */}
            <Box sx={{
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '24px',
                '& > div': {
                    height: '100% !important',
                    p: '0 !important',
                    bgcolor: 'transparent !important'
                }
            }}>
                <PosPage ref={posRef} />
            </Box>
        </Box>
    );
};

export default ReceptionistDashboard;
